module.exports = __webpack_public_path__ + "img/desc4.a47be628.png";